import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '../icon';

const EmptyStateMessage = styled.p`
	margin: 0;
	padding: 1rem;
	text-align: center;
	color: ${({ theme }) => theme['silver-base']};

	svg {
		display: inline-block;
		margin-right: 0.5rem;
		margin-bottom: 0.25rem;
		width: 1rem;
		height: 1rem;
		vertical-align: middle;

		path {
			fill: ${({ theme }) => theme['silver-base']};
		}
	}
`;

const EmptyState = React.memo((props) => {
	const { icon = 'warning', message, ...rest } = props;

	return (
		<EmptyStateMessage data-cy="empty-state" {...rest}>
			<Icon use={icon} />
			{ message }
		</EmptyStateMessage>
	);
});

EmptyState.displayName = 'EmptyState';

EmptyState.propTypes = {
	icon: PropTypes.string,
	message: PropTypes.string.isRequired
};

export default EmptyState;
